import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { BUSINESS, NAV_LINKS } from "../../mocks/siteData";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <header
        className="fixed top-0 left-0 right-0 z-50 bg-charcoal-dark border-b border-white/8"
        style={{ backdropFilter: "blur(12px)" }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center justify-between h-20 md:h-28">
            {/* Logo — always inverted on dark header */}
            <Link to="/" className="flex-shrink-0">
              <img
                src={BUSINESS.logoUrl}
                alt="The Lash Bar"
                className="h-14 md:h-20 w-auto object-contain brightness-0 invert"
                title="The Lash Bar — Lehi, Utah"
              />
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  rel="nofollow"
                  className={`font-sans text-sm tracking-widest uppercase text-white/85 hover:text-gold transition-colors duration-200 ${
                    location.pathname === link.href ? "text-gold" : ""
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href={BUSINESS.phoneTel}
                className="font-sans text-base font-medium text-white hover:text-gold transition-colors duration-200 tracking-wide"
              >
                <i className="ri-phone-line mr-1.5" />
                {BUSINESS.phone}
              </a>
              <a
                href={BUSINESS.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold text-xs py-3 px-6"
              >
                Book Now
              </a>
            </nav>

            {/* Mobile: Phone + Hamburger */}
            <div className="flex md:hidden items-center gap-4">
              <a href={BUSINESS.phoneTel} className="text-white hover:text-gold transition-colors">
                <i className="ri-phone-line text-xl" />
              </a>
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="text-white hover:text-gold transition-colors"
                aria-label="Toggle menu"
              >
                <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className={`md:hidden transition-all duration-400 overflow-hidden bg-charcoal-dark ${
            menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="font-sans text-xs tracking-widest uppercase text-white/80 hover:text-gold transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <a
              href={BUSINESS.phoneTel}
              className="font-sans text-xs tracking-wider text-white/80 hover:text-gold transition-colors"
            >
              {BUSINESS.phone}
            </a>
            <a
              href={BUSINESS.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold text-center mt-2"
            >
              Book an Appointment
            </a>
          </div>
        </div>
      </header>
    </>
  );
}
